import React from "react";
import PropTypes from "prop-types";
import ModalApp from "../ModalApp";
import { FormNewCard } from "../FormCard";

export default function AddCardModal({
  cardMgmt,
  cards,
  isMyAccountPage = false,
}) {
  return (
    <ModalApp
      show={cardMgmt.boxNewCard}
      handleModal={cardMgmt.closeAddCardModal}
      desktopSize="medium"
    >
      <FormNewCard
        saveNewCard={cardMgmt.saveNewCard}
        onCancel={cardMgmt.closeAddCardModal}
        cards={cards}
        isMyAccountPage={isMyAccountPage}
        Loading={cardMgmt.isLoading}
      />
    </ModalApp>
  );
}

AddCardModal.propTypes = {
  cardMgmt: PropTypes.shape({
    boxNewCard: PropTypes.bool,
    openAddCardModal: PropTypes.func,
    closeAddCardModal: PropTypes.func,
    saveNewCard: PropTypes.func,
    onClickDelCard: PropTypes.func,
    isLoading: PropTypes.bool,
  }).isRequired,
  cards: PropTypes.array,
  isMyAccountPage: PropTypes.bool,
};
